import { cn } from "@/lib/utils";

/**
 * Classnora logo mark rendered as a custom "Cn✦" badge
 * paired with the wordmark "Class" + italic terracotta "nora".
 */
export function LogoMark({ className = "w-9 h-9" }) {
  return (
    <span
      aria-hidden="true"
      className={cn(
        "relative inline-flex shrink-0 items-center justify-center rounded-md border border-[var(--cn-sage-soft)] bg-[var(--cn-sage-bg)] font-sans text-[0.92rem] font-semibold leading-none tracking-tight text-[var(--cn-ink)]",
        className,
      )}
    >
      <span>Cn</span>
      <span className="absolute right-[10%] top-[10%] text-[0.58rem] font-bold text-[var(--cn-terra-dark)]">
        ✦
      </span>
    </span>
  );
}

export default function Logo({
  size = "default",
  tone = "default",
  className,
  showWordmark = true,
  markClassName,
}) {
  const dim = size === "small" ? "w-7 h-7" : "w-9 h-9";
  const text = size === "small" ? "text-lg" : "text-2xl";
  const isInverse = tone === "inverse";

  if (!showWordmark) {
    return (
      <div className={cn("flex justify-center", className)}>
        <LogoMark className={cn(dim, markClassName)} />
      </div>
    );
  }

  return (
    <div className={cn("flex items-center gap-2.5", className)}>
      <LogoMark className={cn(dim, markClassName)} />
      <span
        className={`font-display ${text} leading-none tracking-tight ${
          isInverse ? "text-[var(--cn-cream)]" : "text-ink"
        }`}
      >
        Class
        <span
          className={`italic font-medium ${
            isInverse ? "text-[var(--cn-terra-soft)]" : "text-terra"
          }`}
        >
          nora
        </span>
      </span>
    </div>
  );
}
